import {doSuccessFailureActions} from '../_utils/actions.js';

export const FETCH_GROOMER_PLANNING = doSuccessFailureActions('FETCH_GROOMER_PLANNING');
export const ADD_JUSTIFICATION = doSuccessFailureActions('ADD_JUSTIFICATION');

export function fetchGroomerPlanningForYearAndMonth(groomer, year, month) {
  return {type: FETCH_GROOMER_PLANNING.do, groomer, year, month};
}

export function fetchGroomerPlanningForYearAndMonthSuccess(items, groomer, year, month) {
  return {type: FETCH_GROOMER_PLANNING.success, items, groomer, year, month};
}

export function fetchGroomerPlanningForYearAndMonthFailure(err, groomer, year, month) {
  return {type: FETCH_GROOMER_PLANNING.failure, err, groomer, year, month};
}

export function addJustification(groomer, year, month, day, message) {
  return {type: ADD_JUSTIFICATION.do, groomer, year, month, day, message}
}

export function addJustificationSuccess(groomer, year, month, day, message) {
  return {type: ADD_JUSTIFICATION.success, groomer, year, month, day, message}
}

export function addJustificationFailure(err) {
  return {type: ADD_JUSTIFICATION.failure, err};
}



// WEBPACK FOOTER //
// ./src/redux/planning/actions.js